var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',_vm._g({staticClass:"w-9 h-7 flex items-center justify-center rounded-lg px-1",class:[_vm.active ? 'bg-primary text-white ':'cursor-pointer hover:text-primary']},_vm.listeners),[_c('base-icon',{attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }